/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveaways_Freenow1Inputs */

const id_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Sekarang`)
};

const ms_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percuma Sekarang`)
};

const da_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Nu`)
};

const de_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt kostenlos`)
};

const en_us2_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Now`)
};

const es_es2_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Ahora`)
};

const es_mx2_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis ahora`)
};

const fil_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libre Ngayon`)
};

const fr_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit maintenant`)
};

const it_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis ora`)
};

const hu_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes most`)
};

const nl_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu gratis`)
};

const no_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis nå`)
};

const pl_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe teraz`)
};

const pt_br2_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Now`)
};

const pt_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis agora`)
};

const ro_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit acum`)
};

const fi_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen nyt`)
};

const sv_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis nu`)
};

const vi_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miễn phí ngay`)
};

const tr_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Ücretsiz`)
};

const cs_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyní zdarma`)
};

const bg_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатно сега`)
};

const ru_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейчас бесплатно`)
};

const uk_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовно зараз`)
};

const ar_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني الآن`)
};

const hi_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी मुफ़्त`)
};

const th_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรีตอนนี้`)
};

const ja_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ無料`)
};

const zh_cn2_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Now`)
};

const zh_hant1_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Now`)
};

const ko_components_giveaways_freenow1 = /** @type {(inputs: Components_Giveaways_Freenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Now`)
};

/**
* | output |
* | --- |
* | "Free Now" |
*
* @param {Components_Giveaways_Freenow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveaways_freenow1 = /** @type {((inputs?: Components_Giveaways_Freenow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveaways_Freenow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveaways_freenow1(inputs)
	if (locale === "ms") return ms_components_giveaways_freenow1(inputs)
	if (locale === "da") return da_components_giveaways_freenow1(inputs)
	if (locale === "de") return de_components_giveaways_freenow1(inputs)
	if (locale === "en-US") return en_us2_components_giveaways_freenow1(inputs)
	if (locale === "es-ES") return es_es2_components_giveaways_freenow1(inputs)
	if (locale === "es-MX") return es_mx2_components_giveaways_freenow1(inputs)
	if (locale === "fil") return fil_components_giveaways_freenow1(inputs)
	if (locale === "fr") return fr_components_giveaways_freenow1(inputs)
	if (locale === "it") return it_components_giveaways_freenow1(inputs)
	if (locale === "hu") return hu_components_giveaways_freenow1(inputs)
	if (locale === "nl") return nl_components_giveaways_freenow1(inputs)
	if (locale === "no") return no_components_giveaways_freenow1(inputs)
	if (locale === "pl") return pl_components_giveaways_freenow1(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveaways_freenow1(inputs)
	if (locale === "pt") return pt_components_giveaways_freenow1(inputs)
	if (locale === "ro") return ro_components_giveaways_freenow1(inputs)
	if (locale === "fi") return fi_components_giveaways_freenow1(inputs)
	if (locale === "sv") return sv_components_giveaways_freenow1(inputs)
	if (locale === "vi") return vi_components_giveaways_freenow1(inputs)
	if (locale === "tr") return tr_components_giveaways_freenow1(inputs)
	if (locale === "cs") return cs_components_giveaways_freenow1(inputs)
	if (locale === "bg") return bg_components_giveaways_freenow1(inputs)
	if (locale === "ru") return ru_components_giveaways_freenow1(inputs)
	if (locale === "uk") return uk_components_giveaways_freenow1(inputs)
	if (locale === "ar") return ar_components_giveaways_freenow1(inputs)
	if (locale === "hi") return hi_components_giveaways_freenow1(inputs)
	if (locale === "th") return th_components_giveaways_freenow1(inputs)
	if (locale === "ja") return ja_components_giveaways_freenow1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveaways_freenow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveaways_freenow1(inputs)
	return ko_components_giveaways_freenow1(inputs)
});
export { components_giveaways_freenow1 as "components.giveaways.freeNow" }